export default __webpack_public_path__ + "static/media/pvilla2-1.fd0753d0.jpg";